import { render, staticRenderFns } from "./admin-manufacturerDelete.vue?vue&type=template&id=575c6868&"
import script from "./admin-manufacturerDelete.vue?vue&type=script&lang=js&"
export * from "./admin-manufacturerDelete.vue?vue&type=script&lang=js&"
import style0 from "./admin-manufacturerDelete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports